// Edad en español natural, calculada desde birth_date (YYYY-MM-DD).
// Reglas:
// - >= 1 año: "X años, Y meses" (omite ", 0 meses")
// - < 1 año, >= 1 mes: "X meses"
// - < 1 mes: "X días"
// - 0 días o futuro: "0 días"

function parseIsoDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

function pluralize(n: number, singular: string, plural: string): string {
  return `${n} ${n === 1 ? singular : plural}`;
}

export function formatAge(
  birthDate: string | null | undefined,
  reference: Date = new Date(),
): string {
  if (!birthDate) return "—";
  const birth = parseIsoDate(birthDate);
  if (!birth) return "—";

  if (birth.getTime() > reference.getTime()) return "0 días";

  let years = reference.getFullYear() - birth.getFullYear();
  let months = reference.getMonth() - birth.getMonth();
  let days = reference.getDate() - birth.getDate();

  if (days < 0) {
    months -= 1;
    // Días en el mes previo a la referencia
    const prevMonth = new Date(reference.getFullYear(), reference.getMonth(), 0);
    days += prevMonth.getDate();
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  if (years >= 1) {
    if (months === 0) return pluralize(years, "año", "años");
    return `${pluralize(years, "año", "años")}, ${pluralize(months, "mes", "meses")}`;
  }

  if (months >= 1) return pluralize(months, "mes", "meses");

  return pluralize(days, "día", "días");
}
